(function () {
  var COLLAPSED = 132; // muss zu max-height in .cat-seo__body passen

  function init(root) {
    var body = root.querySelector('[data-seo-body]');
    var btn = root.querySelector('[data-seo-toggle]');
    var label = root.querySelector('[data-seo-label]');
    if (!body || !btn) return;

    function measure() {
      if (root.dataset.open === 'true') {
        body.style.maxHeight = body.scrollHeight + 'px';
      } else {
        var fits = body.scrollHeight <= COLLAPSED + 8;
        root.dataset.fits = fits ? 'true' : 'false';
      }
    }

    btn.addEventListener('click', function () {
      var open = root.dataset.open !== 'true';
      root.dataset.open = open ? 'true' : 'false';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore;
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '';
    });

    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    window.addEventListener('resize', measure);
  }

  function initAll() {
    document.querySelectorAll('[data-cat-seo]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-cat-seo]').forEach(init);
  });
})();